/**
 * @fileoverview Authentication utility functions.
 * Provides helper functions for handling authentication-related
 * errors and responses throughout the application.
 * @module lib/authUtils
 */

/**
 * Checks if an error represents an unauthorized (401) response.
 * Used to detect session expiration and trigger re-authentication.
 * @param error - Error object to check
 * @returns True if error indicates 401 Unauthorized response
 */
export function isUnauthorizedError(error: Error): boolean {
  return /^401: .*Unauthorized/.test(error.message);
}
